import { useAccountContext } from "@/state/providers/AccountProvider";
import { PIMSType } from "@/common/utils/types";
import { IntegrationProvider } from "@/features/settings/components/integrations/Integrations";

export const useIsPulse = (): boolean => {
    const { accountData, pmsIntegrationData } = useAccountContext();
    return (
        accountData?.current_pims === PIMSType.PULSE ||
        (pmsIntegrationData?.some(
            (i) =>
                i.connected_third_party === IntegrationProvider.Pulse ||
                i.integrations?.integration_name === IntegrationProvider.Pulse,
        ) ??
            false)
    );
};
